export default __webpack_public_path__ + "static/fred_catona-dd7b0bab91217afc83654af2763bc6b5.jpeg";